import React from 'react';
export function Card({
  title,
  description,
  action,
  children,
  className = ''
}: {
  title?: string;
  description?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`bg-white rounded-lg border border-[#E2E8F0] shadow-sm ${className}`} data-id="element-2937" data-mp="1xe223217muey">
      {(title || action) && <div className="px-6 pt-5 pb-4 flex items-start justify-between gap-4" data-id="element-2938" data-mp="1sfqnyf3vtxqx">
          <div data-id="element-2939" data-mp="2q0mrhwy4kwfv">
            {title && <h3 className="text-base font-semibold text-[#0F172A] m-0" data-id="element-2940" data-mp="2q167h847tar9">{title}</h3>}
            {description && <p className="text-sm text-[#64748B] mt-1 m-0" data-id="element-2941" data-mp="2l0s07safu4ua">{description}</p>}
          </div>
          {action}
        </div>}
      <div className={title || action ? 'px-6 pb-6' : 'p-6'} data-id="element-2942" data-mp="2b4oy2mfl667c">{children}</div>
    </div>;
}
export function Toggle({
  on,
  onChange,
  label
}: {
  on: boolean;
  onChange: (v: boolean) => void;
  label?: string;
}) {
  return <button type="button" onClick={() => onChange(!on)} aria-pressed={on} aria-label={label} className={`w-11 h-6 rounded-full relative transition-colors flex-shrink-0 ${on ? 'bg-[#0EA5E9]' : 'bg-[#CBD5E1]'}`} data-id="element-2943" data-mp="zp095pirux3w">
      <div className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow-sm transition-transform ${on ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-2944" data-mp="1jtpm85vkx55q" />
    </button>;
}
export function FieldLabel({
  children,
  hint
}: {
  children: React.ReactNode;
  hint?: string;
}) {
  return <div className="mb-1.5" data-id="element-2945" data-mp="w5g2d9hxerh8">
      <label className="block text-xs font-medium text-[#475569]" data-id="element-2946" data-mp="w4ehkdb3yqmb">{children}</label>
      {hint && <p className="text-xs text-[#94A3B8] m-0 mt-0.5" data-id="element-2947" data-mp="10wy5o47f945d">{hint}</p>}
    </div>;
}
export const inputClass = 'w-full h-10 px-3 border border-[#CBD5E1] rounded-md text-sm text-[#0F172A] focus:border-[#0EA5E9] focus:ring-1 focus:ring-[#0EA5E9] focus:outline-none bg-white';
export const textareaClass = 'w-full px-3 py-2 border border-[#CBD5E1] rounded-md text-sm text-[#0F172A] focus:border-[#0EA5E9] focus:ring-1 focus:ring-[#0EA5E9] focus:outline-none bg-white resize-none';
export function SegmentedControl<T extends string>({
  value,
  options,
  onChange
}: {
  value: T;
  options: {
    value: T;
    label: string;
  }[];
  onChange: (v: T) => void;
}) {
  return <div className="inline-flex bg-[#F1F5F9] rounded-lg p-1" data-id="element-2948" data-mp="2a4hy84u76fwa">
      {options.map(o => <button key={o.value} type="button" onClick={() => onChange(o.value)} className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${value === o.value ? 'bg-white text-[#0F172A] shadow-sm' : 'text-[#64748B] hover:text-[#0F172A]'}`} data-id="element-2949" data-mp="2a2exaprib2cs">
          {o.label}
        </button>)}
    </div>;
}
export function StatusPill({
  status
}: {
  status: string;
}) {
  const map: Record<string, string> = {
    Sent: 'bg-[#D1FAE5] text-[#059669]',
    Scheduled: 'bg-[#DBEAFE] text-[#2563EB]',
    Repeating: 'bg-[#EDE9FE] text-[#6D28D9]',
    Sending: 'bg-[#FEF3C7] text-[#D97706]',
    Failed: 'bg-[#FEE2E2] text-[#DC2626]',
    Cancelled: 'bg-[#F1F5F9] text-[#64748B]',
    On: 'bg-[#D1FAE5] text-[#059669]',
    Off: 'bg-[#F1F5F9] text-[#64748B]',
    'Phase 2': 'bg-[#FEF3C7] text-[#B45309]'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-xl text-[12px] font-medium ${map[status] || 'bg-[#F1F5F9] text-[#475569]'}`} data-id="element-2950" data-mp="3t3fivs6lhp6b">
      {status}
    </span>;
}